export default __webpack_public_path__ + "static/media/MarsCentra-Book.fbf751ed.eot";